import { z } from 'zod';

import zodLocales from 'common/zod/locales';

const capitalDepositEUBankAccountSchema = z.object({
  hasEuropeanBankAccount: z.boolean({
    invalid_type_error: zodLocales.errors.required,
    required_error: zodLocales.errors.required,
  }),
});

export type CapitalDepositEUBankAccountSchema = z.infer<
  typeof capitalDepositEUBankAccountSchema
>;

export default capitalDepositEUBankAccountSchema;
